import React, { useState, useEffect, useCallback } from 'react'
import debounce from 'lodash/debounce' // Assurez-vous que lodash est installé
import styles from './TextAreaInput.module.css'

function TextAreaInput({ name, value, onChange }) {
  const [localValue, setLocalValue] = useState(value)

  // Mettre à jour l'état local lorsque la valeur globale change
  useEffect(() => {
    setLocalValue(value)
  }, [value])

  // Fonction déclenchée après un délai pour limiter les mises à jour fréquentes
  const debouncedOnChange = useCallback(
    debounce((name, newValue) => {
      onChange({ target: { name, value: newValue } })
    }, 500),
    []
  )

  // Gestionnaire d'événement pour chaque changement dans la zone de texte
  const handleInputChange = useCallback(
    (event) => {
      setLocalValue(event.target.value) // Mise à jour de l'état local
      debouncedOnChange(name, event.target.value) // Appel décalé de onChange
    },
    [name, debouncedOnChange]
  )

  return (
    <div className={styles.container}>
      <textarea name={name} value={localValue} onChange={handleInputChange} />
    </div>
  )
}

export default TextAreaInput
